import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class DriverTeamsFilterEntity {
  id?: number
  driver?: DriverEntity
  name?: string
  searchWord?: string
  page?: number
  limit?: number
}
